module.exports = __webpack_public_path__ + "img/pingjia5.16d2288e.png";